import MainLayout from "layouts/MainLayout";

const Contact = () => {
    return (
        <MainLayout>
            This is Contact page
        </MainLayout>
    )
}

export default Contact;